import classNames from 'classnames';
import * as React from 'react';

export interface DecisionGateProps {
    badge: React.ReactNode;
    title: string;
    sub: string;
    signedInAs?: React.ReactNode;
    brand?: React.ReactNode;
    note?: React.ReactNode;
    actions: React.ReactNode;
    escape?: React.ReactNode;
    centered?: boolean;
    card?: boolean;
    className?: string;
    children: React.ReactNode;
}

// The blocking post-sign-in host: brand, a head naming the child, exactly one child, and the
// child's own bottom-pinned actions. The host renders no skip, back or close — an escape hatch
// belongs to the child that needs one.
export const DecisionGate: React.FunctionComponent<DecisionGateProps> = (
    {badge, title, sub, signedInAs, brand, note, actions, escape, centered, card, className, children}: DecisionGateProps
) => (
    <div className={classNames('mp-decision-gate', {'mp-decision-gate--centered': centered, 'mp-decision-gate--card': card}, className)}>
        {brand && <div className="mp-decision-gate__brand">{brand}</div>}
        <div className="mp-decision-gate__head">
            <span className="mp-decision-gate__badge">{badge}</span>
            <h1 className="mp-decision-gate__title">{title}</h1>
            <p className="mp-decision-gate__sub">{sub}</p>
            {signedInAs && <span className="mp-decision-gate__signed">{signedInAs}</span>}
        </div>
        <div className="mp-decision-gate__child">{children}</div>
        <div className="mp-decision-gate__actions">
            {note && <p className="mp-decision-gate__note">{note}</p>}
            {actions}
            {escape && <div className="mp-decision-gate__escape">{escape}</div>}
        </div>
    </div>
);
